import { EFlightAreaType } from '../types/flight-area'
import { getRoot } from '/@/root'
import rootStore from '/@/store'
import { GeojsonCoordinate } from '/@/types/map'

export function useGMapCover () {
  const root = getRoot()
  const L = root.$leaflet
  const map = root.$map

  const normalColor = '#2D8CF0'
  const store = rootStore
  const coverMap = store.state.coverMap
  const flightAreaColorMap = {
    [EFlightAreaType.DFENCE]: '#19be6b',
    [EFlightAreaType.NFZ]: '#ff0000',
  }
  const disableColor = '#b3b3b3'

  function AddCoverToMap (cover: any) {
    coverMap[cover.options.extData.id] = [cover]
  }

  function getPinIcon (color?: string) {
    const colorObj: { [key: string]: string } = {
      '2d8cf0': '/assets/icons/pin-2d8cf0.svg',
      '19be6b': '/assets/icons/pin-19be6b.svg',
      212121: '/assets/icons/pin-212121.svg',
      b620e0: '/assets/icons/pin-b620e0.svg',
      e23c39: '/assets/icons/pin-e23c39.svg',
      ffbb00: '/assets/icons/pin-ffbb00.svg',
    }
    const iconName = (color?.replaceAll('#', '') || '').toLocaleLowerCase()

    return L.icon({
      iconUrl: colorObj[iconName] || colorObj['2d8cf0'],
      iconSize: [40, 50],
      iconAnchor: [20, 50]
    })
  }

  function init2DPin (name: string, coordinates: GeojsonCoordinate, color?: string, data?: {}) {
    const marker = L.marker([coordinates[1], coordinates[0]], {
      title: name,
      icon: getPinIcon(color)
    }).addTo(map)

    marker.options.extData = data
    AddCoverToMap(marker)
  }

  function AddOverlayGroup (overlay: any) {
    const id = overlay.options.extData.id
    coverMap[id] = [...(coverMap[id] || []), overlay]
  }

  function initPolyline (name: string, coordinates: GeojsonCoordinate[], color?: string, data?: {}) {
    const latlngs = coordinates.map(coord => [coord[1], coord[0]])

    const polyline = L.polyline(latlngs, {
      color: color || normalColor,
      weight: 2,
      opacity: 1
    }).addTo(map)

    polyline.options.extData = data
    AddOverlayGroup(polyline)
  }

  function initPolygon (name: string, coordinates: GeojsonCoordinate[][], color?: string, data?: {}) {
    const latlngs = coordinates[0].map(coord => [coord[1], coord[0]])

    const polygon = L.polygon(latlngs, {
      color: color || normalColor,
      weight: 2,
      opacity: 1,
      fillColor: color || normalColor,
      fillOpacity: 0.4
    }).addTo(map)

    polygon.options.extData = data
    AddOverlayGroup(polygon)
  }

  function removeCoverFromMap (id: string) {
    if (coverMap[id]) {
      coverMap[id].forEach(cover => {
        map.removeLayer(cover)
      })
      coverMap[id] = []
    }
  }

  function getElementFromMap (id: string): any[] {
    return coverMap[id] || []
  }

  // Update methods for existing elements
  function updatePinElement (id: string, name: string, coordinates: GeojsonCoordinate, color?: string) {
    const elements = getElementFromMap(id)
    elements.forEach(element => {
      element.setLatLng([coordinates[1], coordinates[0]])
      element.setIcon(getPinIcon(color))
    })
  }

  function updatePolylineElement (id: string, name: string, coordinates: GeojsonCoordinate[], color?: string) {
    const elements = getElementFromMap(id)
    const latlngs = coordinates.map(coord => [coord[1], coord[0]])
    elements.forEach(element => {
      element.setLatLngs(latlngs)
      element.setStyle({ color: color || normalColor })
    })
  }

  function updatePolygonElement (id: string, name: string, coordinates: GeojsonCoordinate[][], color?: string) {
    const elements = getElementFromMap(id)
    const latlngs = coordinates[0].map(coord => [coord[1], coord[0]])
    elements.forEach(element => {
      element.setLatLngs(latlngs)
      element.setStyle({
        color: color || normalColor,
        fillColor: color || normalColor
      })
    })
  }

  return {
    init2DPin,
    initPolyline,
    initPolygon,
    AddOverlayGroup,
    removeCoverFromMap,
    getElementFromMap,
    updatePinElement,
    updatePolylineElement,
    updatePolygonElement
  }
}
